import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

import './style.scss';

import Icon from '../../../Common/Icon';
import ConfigService from '../../../../Services/api/Config';
import Utils from '../../../../Services/Utils';

import { ReactComponent as EditIcon } from '../../../../../img/icon-template-edit.svg';
import { ReactComponent as DeleteIcon } from '../../../../../img/icon-delete.svg';
import { ReactComponent as CloneIcon } from '../../../../../img/icon-clone.svg';
import { ReactComponent as NoteIcon } from '../../../../../img/icon-note.svg';
import { ReactComponent as AttachmentIcon } from '../../../../../img/icon-attachments.svg';
import { ReactComponent as ScoreIcon } from '../../../../../img/icon-score.svg';
import { ReactComponent as TriggerIcon } from '../../../../../img/icon-trigger.svg';
import { ReactComponent as ConditionIcon } from '../../../../../img/icon-eye.svg';
import { ReactComponent as CloseIcon } from "../../../../../img/dialog-close.svg";
import { ReactComponent as CheckIcon } from "../../../../../img/icon-undelete.svg";
import { ReactComponent as ErrorIcon } from "../../../../../img/icon-error.svg";
import { ReactComponent as ArrowEmptyRightIcon } from "../../../../../img/icon-arrow-empty-right.svg";
import { ReactComponent as ArrowEmptyDownIcon } from "../../../../../img/icon-arrow-empty-down.svg";
import { ReactComponent as DotsIcon } from "../../../../../img/icon-six-dots.svg";
import { ReactComponent as CollapseIcon } from "../../../../../img/icon-collapse.svg";
import { ReactComponent as ExpandIcon } from "../../../../../img/icon-expand.svg";

export const ATTACHMENT_ICON = 'ATTACHMENT_ICON';
export const CONDITION_ICON = 'CONDITION_ICON';
export const CLONE_ICON = 'CLONE_ICON';
export const EDIT_ICON = 'EDIT_ICON';
export const DELETE_ICON = 'DELETE_ICON';
export const NOTE_ICON = 'NOTE_ICON';
export const SCORE_ICON = 'SCORE_ICON';
export const TRIGGER_ICON = 'TRIGGER_ICON';
export const CLOSE_ICON = 'CLOSE_ICON';
export const CHECK_ICON = 'CHECK_ICON';
export const ERROR_ICON = 'ERROR_ICON';
export const RIGHT_ARROW_ICON = 'RIGHT_ARROW_ICON';
export const DOWN_ARROW_ICON = 'DOWN_ARROW_ICON';
export const DOT_ICON = 'DOT_ICON';
export const COLLAPSE_ICON = 'COLLAPSE_ICON';
export const EXPAND_ICON = 'EXPAND_ICON';


const IconSpecs = {
  COLLAPSE_ICON: {
    height: 16,
    width: 16,
    color: 'primaryColor',
    icon: <CollapseIcon alt='icon-right-arrow'/>,
  },
  EXPAND_ICON: {
    height: 16,
    width: 16,
    color: 'primaryColor',
    icon: <ExpandIcon alt='icon-right-arrow'/>,
  },
  RIGHT_ARROW_ICON: {
    height: 16,
    width: 16,
    color: 'primaryColor',
    icon: <ArrowEmptyRightIcon alt='icon-right-arrow'/>,
  },
  DOWN_ARROW_ICON: {
    height: 16,
    width: 16,
    color: 'primaryColor',
    icon: <ArrowEmptyDownIcon alt='icon-down-arrow'/>,
  },
  DOT_ICON: {
    height: 16,
    width: 16,
    color: 'secondaryColor',
    icon: <DotsIcon alt='icon-dot-menu'/>,
  },
  ATTACHMENT_ICON: {
    height: 15,
    width: 17,
    color: 'secondaryColor',
    icon: <AttachmentIcon alt='icon-attachments'/>
  },
  CONDITION_ICON: {
    height: 16,
    width: 18,
    color: 'secondaryColor',
    icon: <ConditionIcon alt='icon-eye'/>,
  },
  CLONE_ICON: {
    height: 18,
    width: 18,
    color: 'secondaryColor',
    icon: <CloneIcon alt='icon-clone'/>,
  },
  EDIT_ICON: {
    height: 18,
    width: 18,
    color: 'secondaryColor',
    icon: <EditIcon alt='icon-template-edit'/>,
  },
  DELETE_ICON: {
    height: 18,
    width: 18,
    color: 'secondaryColor',
    icon: <DeleteIcon alt='icon-delete'/>,
  },
  NOTE_ICON: {
    height: 16,
    width: 16,
    color: 'secondaryColor',
    icon: <NoteIcon alt='icon-note'/>,
  },
  SCORE_ICON: {
    height: 17,
    width: 17,
    color: 'secondaryColor',
    icon: <ScoreIcon alt='icon-score'/>,
  },
  TRIGGER_ICON: {
    height: 17,
    width: 17,
    color: 'secondaryColor',
    icon: <TriggerIcon alt='icon-trigger'/>,
  },
  CLOSE_ICON: {
    height: 12,
    width: 12,
    color: 'secondaryColor',
    icon: <CloseIcon alt='icon-close'/>,
  },
  CHECK_ICON: {
    height: 15,
    width: 15,
    color: 'secondaryColor',
    icon: <CheckIcon alt='icon-check'/>,
  },
  ERROR_ICON: {
    height: 15,
    width: 15,
    color: 'errorColor',
    icon: <ErrorIcon alt='icon-error'/>,
  },
}
const WrapperWidgetIcon = ({ display, type, iconNumber = null, ...props }) => {
  if (!display) {
    return null;
  }

  const { width, height, icon, color } = IconSpecs[type];
  const { className, colorIcon } = props;

  return (
    <Icon 
      width={width} 
      height={height} 
      color={ colorIcon || color }
      className={ classNames('Relative', className) }
      {...props}
    >
      {icon}
      { !Utils.isNull(iconNumber) && (iconNumber > 0) &&
        <span 
          className={'IconNumber'}
          style={{ backgroundColor: ConfigService.getColor('secondaryColor') }}
        >
          {iconNumber}
        </span>
      }
    </Icon>
  )
}

WrapperWidgetIcon.propTypes = {
  display: PropTypes.bool,
  type: PropTypes.string.isRequired,
  iconNumber: PropTypes.number,
}

export default WrapperWidgetIcon;